<template>
  <div class="sidebar" :class="{ open: !!open }">
    <div class="sidebar-bg" @click="handleClose"></div>
    <div class="sidebar-content l-0">
      <div class="d-f fd-c">
        <SidebarHeader
          :title="title"
          :count="usersList.length"
          @close="handleClose"
        />

        <div class="m d-f fd-c g p">
          <div
            v-for="uid in usersList"
            :key="uid"
            class="custom-btn b-bottom-dark d-f g ai-c p-ver"
            @click="handleUserClick(uid)"
          >
            <ImageWithInitials
              :src="getProfileImageByUid(uid)"
              :name="getProfileNameByUid(uid) || 'A'"
              :show-placeholder="true"
              size="40"
              :border="true"
            />
            <div>{{ getProfileNameByUid(uid) || "..." }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageWithInitials from "@/components/misc/ImageWithInitials.vue";
import SidebarHeader from "@/components/navigation/SidebarHeader.vue";

export default {
  name: "UsersListSidebar",
  components: {
    ImageWithInitials,
    SidebarHeader,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    usersList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    handleUserClick(uid) {
      this.$emit("user-click", uid);
    },
  },
  computed: {
    ...mapGetters(["getProfileImageByUid", "getProfileNameByUid"]),
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
</style>
